<div class="container">
  <mat-tab-group [selectedIndex]="selected.value" (selectedTabChange)="selected.setValue($event.index)">
    <mat-tab label="Histórico Entradas" >
      <div  class="mt-4">
        <data-table
          [titleExcelFile]="'histórico_entrada_inventario'"
          [columns]='columnsII'
          [configuration]='configurationII'
          [reloadTable]='reloadTablaII'
          [params]='[]'
          [url]='urlTableII'
          (add)='addII($event)'
          (edit)='editII($event)'
          (view)='viewDetail($event)'
          [headerFilters]="headerFilters"
          [headerFileXlsm]="headerFileXlsm"
        ></data-table>
      </div>

    </mat-tab>
    @if (selected.value == 1 || selected.value == 2) {
      <mat-tab label="Entrada">
        <div style="width: 100%">
          <app-button-label [labelsEdit]="labels">
          </app-button-label>
          <data-table
            [titleExcelFile]="'entrada_inventario'"
            [columns]="columnsDetails"
            [data]="dataDetails"
            [configuration]="configurationDetails"
            [reloadTable]="reloadTablaDetails"
            [headerFileXlsm]="headerDetailsFileXlsm"
            >
          </data-table>
        </div>
      </mat-tab>
    }

    @if (havePurchaseOrder && selected.value == 1 || selected.value == 2 ) {
      <mat-tab label="Detalle Orden de Compra">
        <app-carousel>
          <ng-template carouselItem="1">
            <mat-card appearance="outlined" class="mat-card-c" >
              <mat-card-content class="mat-body-1">
                <div class="d-flex justify-content-end">
                  <div>
                    @if (dataPO.created) {
                      <h4 class="m-0 p-0 text-center font-weight-bold"
                      [style]="movil?'font-size: x-small; line-height: 0.6;':''"> Creación Solicitud</h4>
                    }
                    <h3 class="m-0 p-0 text-center" [style]="movil?'font-size: x-small;':''">{{dataPO.created |
                    dateFormat}}</h3>
                  </div>
                </div>
                <h2 style="display: flex; justify-content: center;"><strong>ORDEN DE COMPRA</strong></h2>
                <h3>Número de orden: {{dataPO.consecutive}}</h3>
                @if (dataPO.comment != '') {
                  <h3>Comentario: {{dataPO.comment}}</h3>
                }
                <h3>Proveedor: {{dataPO.providerName}}</h3>
                <h3>Fecha de recepción: {{dataPO.receptionDate}}</h3>
                <h3>Costo: {{dataPO.totalCost | thousandSeparator}}</h3>
                <hr>
                  <h2>Autorizó: {{dataPO.authorizeName}}</h2>
                  <hr>
                    <h3>Solicita: {{dataPO.requestsName}}</h3>
                  </mat-card-content>
                </mat-card>
              </ng-template>
              <ng-template carouselItem="2">
                <mat-card appearance="outlined" class="mat-card-c">
                  <mat-card-content class="mat-body-1">
                    <h2 style="display: flex; justify-content: center;"><strong>RECURSOS</strong></h2>
                    <data-table
                      [title]=''
                      [columns]='columnsDetails'
                      [configuration]='configurationResoucesPO'
                      [data]="dataResoucesPO">
                    </data-table>
                  </mat-card-content>
                </mat-card>
              </ng-template>
            </app-carousel>
          </mat-tab>
        }

      </mat-tab-group>
    </div>
